import { useMemo } from 'react';

import { useCurrentOperator } from 'Src/feature/operator/useCurrentOperator';

const useCheckPanelFooterPermissions = () => {
  const operator = useCurrentOperator();


  return useMemo(() => {
    const canAddDiscount = operator.permission('pos.checks.discounts.create').isAllowed;
    const canDeleteDiscount = operator.permission('pos.checks.discounts.delete').isAllowed;

    return {
      splitCheck: operator.permission('pos.checks.split.execute').isAllowed,
      mergeChecks: operator.permission('pos.checks.merge.execute').isAllowed,
      transferCheck: operator.permission('pos.checks.transfer.execute').isAllowed,
      voidCheck: operator.permission('pos.checks.void').isAllowed,
      /**
       * @description used for check mutation when there is no more explicit permission.
       * e.g. "Send" would use this permission whereas "Split" would use explicit Split permission.
       */
      updateCheck: operator.permission('pos.checks.update').isAllowed,

      takePayment: operator.permission('pos.checks.payment.accept.execute').isAllowed,

      manageFees: operator.permission('pos.checks.fees.manage').isAllowed,

      /**
       * @description add/delete of discounts is broken to separate permissions
       * but this will be true if _either_ of those is granted.
       */
      manageDiscounts: {
        isAllowed: operator.permission('pos.checks.discounts.manage').isAllowed,
        metadata: operator.permission('pos.checks.discounts.manage').metadata,
      },
      addDiscounts: canAddDiscount,
      removeDiscounts: canDeleteDiscount,
    };
  }, [operator]);
};

export { useCheckPanelFooterPermissions };
